var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenCollapseIconForSubStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1473_793)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.54236,
    y: 27.6062,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-90 0.54236 27.6062)",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3532 13.2183L14.5419 17.0295C14.4645 17.107 14.3825 17.1626 14.296 17.1963C14.2095 17.23 14.1172 17.2468 14.0191 17.2468C13.921 17.2468 13.8287 17.23 13.7422 17.1963C13.6557 17.1626 13.5737 17.107 13.4963 17.0295L9.67191 13.2052C9.52707 13.0603 9.45465 12.8839 9.45465 12.6758C9.45465 12.4677 9.52707 12.2912 9.67191 12.1464C9.81676 12.0015 9.99542 11.9313 10.2079 11.9357C10.4203 11.9401 10.599 12.0147 10.7439 12.1595L14.0191 15.4348L17.3075 12.1464C17.4524 12.0015 17.6266 11.9291 17.8303 11.9291C18.034 11.9291 18.2083 12.0015 18.3532 12.1464C18.498 12.2912 18.5704 12.4699 18.5704 12.6824C18.5704 12.8948 18.498 13.0735 18.3532 13.2183Z",
    fill: "#4A4D53"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.05853,
    y: 27.09,
    width: 25.9677,
    height: 25.9677,
    rx: 12.9838,
    transform: "rotate(-90 1.05853 27.09)",
    stroke: "white",
    strokeWidth: 1.03233
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1473_793"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.54236,
    y: 27.6062,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-90 0.54236 27.6062)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCollapseIconForSubStep);
export default __webpack_public_path__ + "static/media/openCollapseIconForSubStep.17128130.svg";
export { ForwardRef as ReactComponent };